import request from '@/router/axios';

//查询发票类型列表
export function fpList(query) {
  return request({
    url: '/api/invoiceType/get/list',
    method: 'get',
    params: query
  })
}
//提交发票类型
export function fpComit(query) {
  return request({
    url: '/api/invoiceType/add',
    method: 'post',
    data: query
  })
}


//查询开票明细列表
export function kpList(query) {
  return request({
    url: '/api/invoiceDetail/get/list',
    method: 'get',
    params: query
  })
}
//提交开票明细
export function kpComit(query) {
  return request({
    url: '/api/invoiceDetail/add',
    method: 'post',
    data: query
  })
}
//查询有花果账户列表
export function zhList(query){
  return request({
    url: '/api/finAccount/get/list',
    method: 'get',
    params: query
  })
}
//提交有花果账户列表
export function zhComit(query){
  return request({
    url: '/api/finAccount/add',
    method: 'post',
    data: query
  })
}